import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: '',
    loadChildren: () => import('../../layouts/components/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'organisations',
    loadChildren: () => import('../../layouts/components/organisations/organisations.module').then(m => m.OrganisationsModule)
  },
  {
    path: 'general/company',
    loadChildren: () => import('../../layouts/components/company/company.module').then(m => m.CompanyModule)
  },
  {
    path: 'general/department',
    loadChildren: () => import('../../layouts/components/departments/departments.module').then(m => m.DepartmentsModule)
  },
  {
    path: 'general/designation',
    loadChildren: () => import('../../layouts/components/designation/designation.module').then(m => m.DesignationModule)
  },
  {
    path: 'general/dd-mapping',
    loadChildren: () => import('../../layouts/components/ddmapping/ddmapping.module').then(m => m.DdmappingModule)
  },
  {
    path: 'general/admin',
    loadChildren: () => import('../../layouts/components/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'role-access',
    loadChildren: () => import('../../layouts/components/role-access/role-access.module').then(m => m.RoleAccessModule)
  },
  {
    path: 'employees',
    loadChildren: () => import('../../layouts/components/employee/employee.module').then(m => m.EmployeeModule)
  },
  {
    path: 'holiday',
    loadChildren: () => import('../../layouts/components/holiday/holiday.module').then(m => m.HolidayModule)
  },
  {
    path: 'device',
    loadChildren: () => import('../../layouts/components/device/device.module').then(m => m.DeviceModule)
  },
  {
    path: 'leave',
    loadChildren: () => import('../../layouts/components/leave/leave.module').then(m => m.LeaveModule)
  },
  {
    path: 'attendance',
    loadChildren: () => import('../../layouts/components/attendance/attendance.module').then(m => m.AttendanceModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('../../layouts/components/chat/chat.module').then(m => m.ChatModule)
  },
  {
    path: 'transactions',
    loadChildren: () => import('../../layouts/components/transactions/transactions.module').then(m => m.TransactionsModule)
  },
  {
    path: 'tickets',
    loadChildren: () => import('../../layouts/components/ticket/ticket.module').then(m => m.TicketModule)
  },
  {
    path: 'employee-tickets',
    loadChildren: () => import('../../layouts/components/employee-ticket/employee-ticket.module').then(m => m.EmployeeTicketModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('../../layouts/components/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'help',
    loadChildren: () => import('../../layouts/components/help-and-support/help-and-support.module').then(m => m.HelpAndSupportModule)
  },
  {
    path: 'apps',
    loadChildren: () => import('../../layouts/components/app/app.module').then(m => m.AppModule)
  },
  {
    path: 'receipt',
    loadChildren: () => import('../../layouts/components/receipt/receipt.module').then(m => m.ReceiptModule)
  },
  {
    path: 'complaints',
    loadChildren: () => import('../../layouts/components/complaints/complaints.module').then(m => m.ComplaintsModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('../../layouts/components/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('../../layouts/components/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('../../layouts/components/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'orders/:id',
    loadChildren: () => import('../../layouts/components/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'upgrade-plan',
    loadChildren: () => import('../../layouts/components/upgrade-plan/upgrade-plan-routing.module').then(m => m.UpgradePlanRoutingModule)
  }
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('../../landing/pages-list/Landing/Landing.module').then(m => m.LandingModule)
  }
]
